// @mui
import {
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
} from '@mui/material'
import { LoadingButton } from '@mui/lab'

// ----------------------------------------------------------------------

interface IAlertDialogProps extends DialogProps {
  open: boolean
  header: JSX.Element
  body: JSX.Element
  footer?: JSX.Element
  submitLabel?: string
  submitDisabled?: boolean
  submitLoading?: boolean
  onClose(): void
  onSubmit?(): void
  submitId?: string
  cancelId?: string
}

export default function AlertDialog({
  open,
  header,
  body,
  footer,
  submitLabel,
  submitDisabled,
  submitLoading,
  onClose,
  onSubmit,
  submitId,
  cancelId,
  ...other
}: IAlertDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        minWidth: '480px',
        '@media (max-width:480px)': {
          minWidth: 'unset',
        },
      }}
      {...other}
    >
      <DialogTitle>{header}</DialogTitle>
      <DialogContent>
        <DialogContentText>{body}</DialogContentText>
      </DialogContent>
      {footer ? (
        <>{footer}</>
      ) : (
        <DialogActions>
          <LoadingButton
            id={submitId}
            variant="contained"
            onClick={onSubmit}
            disabled={submitDisabled}
            loading={submitLoading}
          >
            {submitLabel}
          </LoadingButton>
          <Button
            id={cancelId}
            variant="outlined"
            onClick={onClose}
            autoFocus
          >
            Cancel
          </Button>
        </DialogActions>
      )}
    </Dialog>
  )
}
